/**
 *拼接url参数
 *
 * @param {*} link
 * @param {*} params
 * @returns url
 */
function concatURI(link, params) {
    const query = []
    params.forEach(item => {
        let val = item.val
        if (val) {
            if (typeof item.val === 'object') {
                val = encodeURIComponent(JSON.stringify(item.val))
            } else {
                val = encodeURIComponent(val)
            }
            query.push(`${item.key}=${val}`)
        }
    })
    return link + (link.includes('?') ? '&' : '?') + query.join('&')
}
function throttle(func, delay) {
    let timer = null
    return event => {
        if (!timer) {
            timer = setTimeout(function() {
                func.call(this, event)
                timer = null
            }, delay)
        }
    }
}
function debounce(fn, wait) {
    let timeout = null
    return event => {
        if (timeout !== null) clearTimeout(timeout)
        timeout = setTimeout(fn.bind(this, event), wait)
    }
}
function sleep(time) {
    return new Promise((resolve, reject) => {
        setTimeout(resolve, time)
    })
}
function isObject(s) {
    return Object.prototype.toString.call(s) === '[object Object]'
}
/**
 *生成随机id
 *
 * @param {number} [length=5]
 * @returns
 */
function genId(length = 5) {
    return Number(
        Math.random()
            .toString()
            .substr(3, length) + Date.now()
    ).toString(36)
}
export { concatURI, throttle, debounce, isObject, sleep,genId }
